import { Reveal } from "./Motion";

const titleSizes = {
  default: "text-4xl sm:text-5xl",
  large: "text-[clamp(2.25rem,11vw,2.75rem)] font-medium sm:text-[3.25rem] lg:text-[3.5rem]",
};

const textSizes = {
  default: "text-base leading-relaxed md:text-lg",
  large: "text-[1.0625rem] leading-[1.75] sm:text-lg",
};

export const SectionHead = ({ eyebrow, title, text, className = "", size = "default" }) => (
  <Reveal className={`w-full max-w-2xl ${className}`}>
    <p className="eyebrow text-center sm:text-left">{eyebrow}</p>
    <h2 className={`font-display mt-4 text-center leading-[1.08] text-[#221e1b] sm:text-left ${titleSizes[size]}`}>{title}</h2>
    {text && <p className={`mt-5 text-[#5d544c] ${textSizes[size]}`}>{text}</p>}
  </Reveal>
);
